import { createAction } from "@reduxjs/toolkit";
import { TriggerBody } from "types/type.module";
import { Direction, ElementTag, StepContent } from "types/types";

export const addChapter = createAction<{ chapterPosition: number }>(
  "producer/addChapter"
);

export const setCurrentStep = createAction<{ currentStep: string | null }>(
  "producer/setCurrentStep"
);

export const setAddElement = createAction("producer/setAddElement");

export const renameChapter = createAction<{
  chapterId?: string;
  chapterPosition: number;
  newName: string;
}>("producer/renameChapter");

export type ElementToDelete = {
  chapterId?: string;
  element: "chapter" | "question" | "trigger" | "element" | "answer";
  frontChapterId?: string;
  chapter?: number;
  step?: number;
  directions?: Direction[];
  questionId?: string;
  frontQuestionId?: string;
  possibleAnswerId?: string;
  frontAnswerId?: string;
  elementToDelete?: any;
  type?: any;
};

export const askToDelete = createAction<ElementToDelete | undefined>(
  "producer/askToDelete"
);

export const addStep = createAction<{
  type: "question" | "conclusion";
  position: number;
  chapter: number;
}>("producer/addStep");

export const addComment = createAction<{
  chapterIndex: number;
  questionIndex: number;
  answerId?: string;
}>("producer/addComment");

export type RichTextFocus = {
  chapter?: number;
  question?: number;
  link?: number;
  reference?: number;
  term?: number;
  answer?: number;
  guide?: number;
  example?: number;
};

export const setRichTextFocus = createAction<RichTextFocus>(
  "producer/setRichTextFocus"
);

export const setQuestionValue = createAction<{
  value: boolean;
  valueName: "multiple" | "conclusion" | "print" | "should_be_hidden";
  questionId?: string;
  frontQuestionId?: string;
}>("producer/setQuestionValue");

export const setCurrentChapter = createAction<string | undefined>(
  "producer/setCurrentChapter"
);

export const renameStep = createAction<{
  chapterPosition: number;
  stepId?: string;
  stepPosition: number;
  value: { type: ElementTag; content: StepContent[] };
}>("producer/renameStep");

export const addGuidesExamples = createAction<{
  id: "guidances" | "examples";
  elementIndex: number;
  isQuestion: boolean;
  chapterId: number;
  questionId: number;
}>("producer/addGuidesExamples");

export const setGuideExample = createAction<{
  // TODO: what's the real type here?
  answerPosition: string | number;
  chapterPosition: number;
  questionPosition: number;
  id: string;
  isQuestion: boolean;
  type: "guidances" | "examples";
  value: { type: ElementTag; content: StepContent[] };
}>("producer/setGuideExample");

export const addOperator = createAction<{
  chapter: number;
  directions: Direction[];
  operator: "and" | "or" | "not";
  step: number;
  trigger: string | TriggerBody;
}>("producer/addOperator");

export const setSelectedTrigger = createAction<{
  trigger: { answer: string; label: string; trigger: TriggerBody };
}>("producer/setSelectedTrigger");

export const deleteElement = createAction<{
  chapter: number;
  directions: Direction[];
  step: number;
}>("producer/deleteElement");

export const addAnswer = createAction<{
  chapter: number;
  step: number;
  order_number: number;
}>("producer/addAnswer");

export const setAnswerValue = createAction<{
  answerId?: string;
  value: boolean;
  valueName: "single";
  frontAnswerId?: string;
}>("producer/setAnswerValue");

export const renameAnswer = createAction<{
  answer?: string;
  frontAnswerId?: string;
  newName: { type: ElementTag; content: StepContent[] };
}>("producer/renameAnswer");

export const changePossibleAnswerOrderNumber = createAction<{
  answerId?: string;
  frontAnswerId?: string;
  orderNumber: number;
  oldOrderNumber: number;
}>("producer/changePossibleAnswerOrderNumber");

export const findConditionToChange = createAction<{
  chapter?: string;
  question?: string;
  answer?: string;
}>("producer/findConditionToChange");

export const changeComment = createAction<{
  comment: string;
  chapterIndex: number;
  questionIndex: number;
  answerId?: string;
}>("producer/changeComment");

export const changeQuestionOrderNumber = createAction<{
  order_number: number;
  oldOrderNumber: number;
  questionId?: string;
  frontQuestionId?: string;
}>("producer/changeQuestionOrderNumber");

export const changeChapterOrderNumber = createAction<{
  order_number: number;
  oldOrderNumber: number;
  chapterId?: string;
  frontChapterId?: string;
}>("producer/changeChapterOrderNumber");

export const changeRichText = createAction<StepContent>(
  "producer/changeRichText"
);

export const removeStep = createAction<{
  chapter: number;
  pos: number;
}>("producer/removeStep");

export const removeChapter = createAction<{
  chapterPos: number;
}>("producer/removeChapter");

export const changeMode = createAction<{
  mode: "chapters";
}>("producer/changeMode");

export const negateTrigger = createAction<{
  directions: Direction[];
  step: number;
  chapter: number;
}>("producer/negateTrigger");

export const addAlways = createAction<{
  step: number;
  chapter: number;
}>("producer/addAlways");

export const addTrigger = createAction<{
  directions: Direction[];
  step: number;
  chapter: number;
  // TODO: is this really string?
  trigger: string;
}>("producer/addTrigger");

export const setShowPopUp = createAction("producer/showPopUp");
export const setShowPopUpOnly = createAction("producer/showPopUpOnly");
export const setClosePopUp = createAction("producer/closePopUp");
export const resetPopUpType = createAction("producer/resetPopUpType");
export const setPopupType = createAction("producer/setPopupType");
export const setProducerUserManualCreation = createAction<{ flag: boolean; }>("producer/setProducerUserManualCreation");